import { Type } from 'bl-common/src/elements/Typography/Typography'
import { Section } from 'bl-common/src/units/Section/Section'

import { withTransition } from '../../../utils/withTransition'
import { Metadata } from '../../Metadata'
import Page from '../../Page'
import { BackToStoriesLink } from './BackToStoriesLink'
import { StoryArchive } from './StoryArchive'

const StoryTagPage = ({ tag, page, stories }) => {
  return (
    <Page breadcrumb={`Topic: ${tag.name} `}>
      <Metadata
        metadata={page.metadata}
        title={`${page.title}: Stories about ${tag.name}`}
        description={`Stories about ${tag.name}`}
      />
      <Section bottom={{ xs: 3, md: 2.5 }}>
        <BackToStoriesLink top={{ xs: 2.5 }} bottom={{ xs: 1.5, md: 5.5 }} />
        <Type size={{ xs: 16, md: 30 }}>Overview of stories about</Type>
        <Type size={{ xs: 16, md: 30 }} weight="bold" case="capitalize">
          {tag.name}
        </Type>
      </Section>
      {!!stories.length && (
        <StoryArchive stories={stories} top={{ md: 8 }} bottom={{ md: 8 }} />
      )}
    </Page>
  )
}

export default withTransition(StoryTagPage)
